import _defineProperty from "/workdir/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _objectWithoutProperties from "/workdir/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js";
const _excluded = ["children"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import React from 'react';
import { Button } from '@hub/button';
import { forwardRef } from '@hub/design-system-base';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const ResponsiveButton = forwardRef((_ref, ref) => {
  let {
      children
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(Button, _objectSpread(_objectSpread({
      ref: ref
    }, props), {}, {
      variant: "utilityOutline",
      sx: {
        width: '100%',
        display: ['none', null, 'block'],
        borderColor: 'borderSecondary'
      },
      "data-id": "action-sheet_responsive-button_ResponsiveButton_Button",
      children: children
    })), /*#__PURE__*/_jsx(Button, _objectSpread(_objectSpread({}, props), {}, {
      variant: "utilityOutlineMobile",
      sx: {
        width: '100%',
        display: ['block', null, 'none'],
        borderColor: 'borderSecondary'
      },
      "data-id": "action-sheet_responsive-button_ResponsiveButton_Button_1",
      children: children
    }))]
  });
});
export default ResponsiveButton;